import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import Fade from 'react-reveal/Fade';
import styled from 'styled-components';

import {
  Accordion,
  AccordionItem,
  AccordionTitle,
  AccordionBody,
  IconWrapper,
  OpenIcon,
  CloseIcon
} from 'common/src/components/Accordion';

import connect from './connect.svg';
import box from './box.svg';
import card from './card.svg';
import fast from './fast.svg';
import hex from './hexagon.svg';
import shield from './shield.svg';
import note from './note.svg';
import track from './track.svg';
import check from './bluecheck.svg';
import goldcheck from './goldcheck.svg';
import silvercheck from './silvercheck.svg';
import platinumcheck from './platinumcheck.svg';

import { thinDown } from 'react-icons-kit/entypo/thinDown';
import { thinUp } from 'react-icons-kit/entypo/thinUp';

import Container from 'common/src/components/UI/Container';

import Heading from 'common/src/components/Heading';

import { Icon } from 'react-icons-kit';

const FirstBlock = styled.div`
  background: rgb(247 249 255);
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 50px;

  .item {
    text-align: center;
    background: #f0f5fb 47%;
    border: 0.5px solid #000000;
    padding: 30px 50px;
    width: 300px;
    margin: 15px 10px;
    cursor: pointer;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);

    &:hover {
      background: -moz-linear-gradient(
        0deg,
        rgba(146, 217, 227, 1) 0%,
        rgba(185, 222, 255, 1) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      background: -webkit-linear-gradient(
        0deg,
        rgba(146, 217, 227, 1) 0%,
        rgba(185, 222, 255, 1) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      background: linear-gradient(
        0deg,
        rgba(146, 217, 227, 1) 0%,
        rgba(185, 222, 255, 1) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#92d9e3",endColorstr="#ffffff",GradientType=1);

      box-shadow: 0px 8px 10px #9e9e9e;
    }

    .img {
      margin-bottom: 10px;
    }

    img {
      width: 65px;
      height: 65px;
    }
    .label {
      font-weight: 600;
      font-size: 18px;
    }
  }
`;

const SecondBlock = styled.div`
  margin-top: 50px;
  background: #000;
  padding: 15px;

  @media (min-width: 992px) {
    padding: 40px;
  }

  .title {
    text-align: center;
    color: #fff;
    font-weight: 500;
    font-size: 23px;

    @media (min-width: 992px) {
      font-size: 38px;
    }
  }

  .buttons {
    text-align: center;
    margin-top: 30px;

    button {
      cursor: pointer;
      color: #fff;
      border: none;
      background: none;
      margin-right: 20px;
      font-weight: 600;
      font-size: 13px;
      @media (min-width: 992px) {
        font-size: 16px;
      }
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      border-radius: 15px;
      padding: 10px 25px;
      border: 1px solid #000;
      border: 1px solid #fff;
    }
    button.active {
      background: linear-gradient(
          180deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0) 100%
        ),
        #eae2e2;

      color: #000000;
    }
  }

  .pricing-content {
    display: flex;
    flex-wrap: wrap;

    @media (min-width: 992px) {
      flex-wrap: nowrap;
    }
    justify-content: center;
    margin-top: 30px;

    .price {
      width: 350px;
      margin: 0 3px;

      &:hover {
        .head {
          margin-top: -15px;
        }
      }

      .head {
        text-align: center;
        margin-bottom: 3px;
        padding: 20px 20px 40px 20px;
        border-radius: 15px;
        transition: 0.3s;

        .title {
          font-weight: 600;
          font-size: 30px;
          color: #000000;
          margin-bottom: 10px;
        }

        .desc {
          font-weight: 600;
          font-size: 14px;
        }
      }

      .body {
        padding: 20px;
        border-radius: 15px;
        margin-bottom: 20px;

        .title {
          display: flex;
          justify-content: center;
          font-weight: 600;
          font-size: 30px;
          color: #000000;
          margin-bottom: 20px;

          .tag {
            font-size: 12px;
            margin: 4px;
          }
        }

        .sub-title {
          font-weight: 600;
          font-size: 17px;
          margin-bottom: 10px;
        }

        .items {
          .item {
            display: flex;

            img {
              width: 15px;
              margin-right: 15px;
            }

            .label {
              font-size: 14px;
              margin-bottom: 10px;
            }
          }
        }
      }

      &.gold {
        @media (min-width: 992px) {
          margin-top: 40px;
        }
      }
    }
  }

  .one-time {
    margin-top: 30px;
    overflow: auto;

    table {
      background: rgb(238, 238, 238);
      color: #222;
      width: 100%;
      border: 10px solid #000;
      border-collapse: collapse;
      border-radius: 10px;

      thead {
        th {
          padding: 10px;
          border-bottom: 10px solid #000;
          font-size: 12px;
          @media (min-width: 992px) {
            font-size: 16px;
          }
        }
      }

      tbody {
        td {
          padding: 10px;
          border-right: 2px solid #000;

          font-size: 12px;
          @media (min-width: 992px) {
            font-size: 16px;
          }

          &:last-child {
            border-right: none;
          }
        }
        td.text-center {
          text-align: center;
        }
      }
    }
  }
`;

const ThirdBlock = styled.div`
  .img-responsive {
    width: 15px;
    @media (min-width: 992px) {
      width: 20px;
    }
  }
  .accordion_body {
    padding: 0;
  }

  .accordion_item {
    border-radius: 5px;
    border: 1px solid #eee;
    box-shadow: 0 1px 2px 0px #ccc;
    margin-bottom: 20px;
  }

  .basisctopser {
    font-size: 16px;
    font-weight: 600;

    @media (min-width: 992px) {
      font-size: 26px;
      font-weight: 600;
    }
  }

  .accordion_title {
    padding: 15px;
    h2 {
      margin-bottom: 0;
    }
  }
  button {
    background: #000000;
    border-radius: 13px;
    padding: 0px 5px;
    color: #fff;
    font-size: 9px;

    @media (min-width: 992px) {
      font-size: 16px;
      font-weight: 600;
      padding: 10px 50px;
    }
  }

  h3 {
    margin-bottom: 5px;
    font-size: 10px;

    @media (min-width: 992px) {
      font-size: 16px;
    }
  }
  table {
    width: 100%;

    th,
    td {
      text-align: left;
      padding: 10px;
      font-size: 9px;

      @media (min-width: 992px) {
        font-size: 16px;
      }
      font-weight: normal;
    }
  }

  .text-center {
    text-align: center;
  }
  .w-20 {
    width: 200px;
  }

  h2 {
    font-size: 16px;
    @media (min-width: 992px) {
      font-size: 26px;
    }
  }

  .table-responsive {
    overflow: auto;
  }
`;

const FourthBlock = styled.div`
  margin-top: 15px;
  @media (min-width: 992px) {
    margin-top: 30px;
  }

  background: rgb(246, 248, 253, 0.5);

  .accordion_item {
    border: 1px solid #ccc;
    box-shadow: 1px 1px 5px 0px #ccc;
    margin-bottom: 20px;
  }

  .accordion_title {
    padding: 15px;
    h2 {
      margin-bottom: 0;
    }
  }

  .accordion_body {
    line-height: 1.5;

    font-size: 12px;
    @media (min-width: 992px) {
      font-size: 16px;
    }
  }

  .title {
    font-size: 22px;
    @media (min-width: 992px) {
      font-size: 30px;
    }
    font-weight: 600;
  }

  .faq-content {
    padding: 10px;
    @media (min-width: 992px) {
      padding: 50px;
    }
    display: flex;
    flex-wrap: wrap;

    @media (min-width: 992px) {
      flex-wrap: nowrap;
    }

    justify-content: center;

    .content {
      width: 100%;
      margin: 0;

      @media (min-width: 992px) {
        margin: 0 25px;
      }
    }

    h2 {
      font-size: 16px;
      @media (min-width: 992px) {
        font-size: 20px;
      }
    }
  }
`;

const PricingBlock = ({ props }) => {
  const myRef = useRef(null);

  useEffect(() => {
    if (props.location.hash === '#faq') myRef.current.scrollIntoView();
  }, []);

  const data = useStaticQuery(graphql`
    query {
      hostingJson {
        SILVER_PLAN {
          plan
          detail
        }
        GOLD_PLAN {
          plan
          detail
        }
        PLATINUM_PLAN {
          plan
          detail
        }
      }
    }
  `);

  const [active, setActive] = useState('compare');

  return (
    <>
      <Container>
        <Fade bottom casacde>
          <SecondBlock>
            <div className="title">
              Start Your FREE Service Today - No Credit Card Required
            </div>

            <div className="buttons">
              <button
                className={active === 'compare' && 'active'}
                onClick={() => setActive('compare')}
              >
                Pricing Plans
              </button>
              <button
                className={active === 'one' && 'active'}
                onClick={() => setActive('one')}
              >
                One-time Services
              </button>
            </div>

            {active === 'compare' ? (
              <div className="pricing-content">
                <Fade left casacde>
                  <div className="price">
                    <div className="head" style={{ background: '#EEEEEE' }}>
                      <div className="title">SILVER</div>
                      <goldcheck></goldcheck>
                      <div className="desc">Non Production VM’s</div>
                    </div>

                    <div className="body" style={{ background: '#EEEEEE' }}>
                      <div className="title">FREE</div>
                      <div className="sub-title">Silver Plan Includes:</div>

                      <div className="items">
                        {data.hostingJson.SILVER_PLAN.map(o => (
                          <div className="item">
                            <div className="img">
                              <img src={silvercheck}></img>
                            </div>
                            <div className="label">{o.detail}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </Fade>
                <Fade bottom casacde>
                  <div className="price gold">
                    <div className="head" style={{ background: '#FFD700' }}>
                      <div className="title">GOLD</div>

                      <div className="desc">Small Business</div>
                    </div>

                    <div className="body" style={{ background: '#EEEEEE' }}>
                      <div className="title">
                        $19.99
                        <div className="tag">
                          Per Month<br></br>
                          Per Server
                        </div>
                      </div>
                      <div className="sub-title">Gold Plan Includes:</div>

                      <div className="items">
                        {data.hostingJson.GOLD_PLAN.map(o => (
                          <div className="item">
                            <div className="img">
                              <img
                                src={
                                  o.plan === 'silver' ? silvercheck : goldcheck
                                }
                              ></img>
                            </div>
                            <div className="label">{o.detail}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </Fade>
                <Fade right casacde>
                  <div className="price">
                    <div className="head" style={{ background: '#9F9F9F' }}>
                      <div className="title">PLATINUM</div>

                      <div className="desc">Large Business</div>
                    </div>

                    <div className="body" style={{ background: '#EEEEEE' }}>
                      <div className="title">
                        $39.99
                        <div className="tag">
                          Per Month<br></br>
                          Per Server
                        </div>
                      </div>
                      <div className="sub-title">Platinum Plan Includes:</div>

                      <div className="items">
                        {data.hostingJson.PLATINUM_PLAN.map(o => (
                          <div className="item">
                            <div className="img">
                              <img
                                src={
                                  o.plan === 'silver'
                                    ? silvercheck
                                    : o.plan === 'gold'
                                    ? goldcheck
                                    : platinumcheck
                                }
                              ></img>
                            </div>
                            <div className="label">{o.detail}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </Fade>{' '}
              </div>
            ) : (
              <Fade bottom casacde>
                <div className="one-time">
                  <table>
                    <thead>
                      <tr>
                        <th>SERVICE NAME</th>
                        <th>DESCRIPTION</th>
                        <th>RHEL</th>
                        <th>SLES</th>
                        <th>WINDOWS</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td className="text-center">High Availability</td>
                        <td>
                          Brand new Cluster Installation - Cost Per One Node
                          Cluster
                        </td>
                        <td className="text-center">$325.00</td>
                        <td className="text-center">$325.00</td>
                        <td className="text-center">$275.00</td>
                      </tr>
                      <tr>
                        <td className="text-center">HA (Custom)</td>
                        <td>
                          Application Level Cluster Configuration - Cost Per
                          Server
                        </td>
                        <td className="text-center">
                          <span
                            style={{ cursor: 'pointer' }}
                            onClick={() => window.Intercom('show')}
                          >
                            CHAT
                          </span>
                        </td>
                        <td className="text-center">
                          <span
                            style={{ cursor: 'pointer' }}
                            onClick={() => window.Intercom('show')}
                          >
                            CHAT
                          </span>
                        </td>
                        <td className="text-center">
                          <span
                            style={{ cursor: 'pointer' }}
                            onClick={() => window.Intercom('show')}
                          >
                            CHAT
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">Disaster Recovery</td>
                        <td>Per server/month - With 3 years Commit </td>
                        <td className="text-center">$37.00</td>
                        <td className="text-center">$37.00</td>
                        <td className="text-center">$37.00</td>
                      </tr>
                      <tr>
                        <td className="text-center">Disaster Recovery</td>
                        <td>Per server/month - With 1 year Commit</td>
                        <td className="text-center">$70.00</td>
                        <td className="text-center">$70.00</td>
                        <td className="text-center">$70.00</td>
                      </tr>

                      <tr>
                        <td className="text-center">DR Maintenance</td>
                        <td>Server has to be part of platinum</td>
                        <td className="text-center">$39.99</td>
                        <td className="text-center">$39.99</td>
                        <td className="text-center">$39.99</td>
                      </tr>

                      <tr>
                        <td className="text-center">DRAAS</td>
                        <td>
                          Per server/month  - Setup + Maintenance (3 years
                          subscription)
                        </td>
                        <td className="text-center">$76.99</td>
                        <td className="text-center">$76.99</td>
                        <td className="text-center">$76.99</td>
                      </tr>

                      <tr>
                        <td className="text-center">Identity Management</td>
                        <td>Enabling MFA & single sign on. Cost per server</td>
                        <td className="text-center">$19.99</td>
                        <td className="text-center">$19.99</td>
                        <td className="text-center">$19.99</td>
                      </tr>

                      <tr>
                        <td className="text-center">On-Boarding</td>
                        <td>
                          Cloud Setup - Subscription creation, VNET, Subnet
                        </td>
                        <td className="text-center">$19.99</td>
                        <td className="text-center">$19.99</td>
                        <td className="text-center">$19.99</td>
                      </tr>

                      <tr>
                        <td className="text-center">Cloud Runbook</td>
                        <td>
                          Initiating actions from pre-defined templates{' '}
                          <br></br>
                          Create runbooks in Azure<br></br>
                          Configure webhooks
                        </td>
                        <td className="text-center">$19.99</td>
                        <td className="text-center">$19.99</td>
                        <td className="text-center">$19.99</td>
                      </tr>

                      <tr>
                        <td className="text-center">Cloud Migration</td>
                        <td>Per server cost - AS IS only</td>
                        <td className="text-center">$139.99</td>
                        <td className="text-center">$139.99</td>
                        <td className="text-center">$139.99</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Fade>
            )}
          </SecondBlock>
        </Fade>

        <Fade bottom casacde>
          <ThirdBlock>
            <div className="table-responsive mt-4 ">
              <table className="table">
                <thead className="noborder basisctop">
                  <tr>
                    <th> </th>
                    <th></th>

                    <th className="pr-3 pl-3 w-20 text-center">
                      <h3 className="text-center">SILVER</h3>
                      <a href="#">
                        {' '}
                        <button className="btn btn-primary ">FREE</button>{' '}
                      </a>
                    </th>
                    <th className="pr-3 pl-3 w-20 text-center">
                      <h3 className="text-center">GOLD</h3>
                      <a href="#">
                        {' '}
                        <button className="btn btn-primary ">
                          $19.99
                        </button>{' '}
                      </a>
                    </th>
                    <th className="pr-3 pl-3 w-20 text-center">
                      <h3 className="text-center">PLATINUM</h3>
                      <a href="#">
                        {' '}
                        <button className="btn btn-primary ">
                          $39.99
                        </button>{' '}
                      </a>
                    </th>
                  </tr>
                </thead>
                <thead className="noborder">
                  <tr>
                    <th>
                      <div className="basisctopser">Services</div>
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th scope="col">24 X 7 Monitoring </th>
                    <th className="w-20"></th>
                    <th scope="col" className="text-center w-20">
                      Basic
                    </th>
                    <th scope="col" className="text-center w-20">
                      Advanced
                    </th>
                    <th scope="col" className="text-center w-20">
                      Advanced Custom
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">24 X 7 Support via Phone Chat and Email</th>
                    <td></td>
                    <td className="text-center">
                      <img
                        src={silvercheck}
                        className="img-responsive"
                        alt=""
                      />
                    </td>
                    <td className="text-center">
                      <img src={goldcheck} className="img-responsive" alt="" />
                    </td>
                    <td className="text-center">
                      <img
                        src={platinumcheck}
                        className="img-responsive"
                        alt=""
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Remote Management and Troubleshooting</th>
                    <td></td>
                    <td className="text-center"></td>
                    <td className="text-center">
                      <img src={goldcheck} className="img-responsive" alt="" />
                    </td>
                    <td className="text-center">
                      <img
                        src={platinumcheck}
                        className="img-responsive"
                        alt=""
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Fade bottom casacde>
              <Accordion preExpanded={['one']}>
                <>
                  <AccordionItem className="accordion_item" uuid="one">
                    <>
                      <AccordionTitle className="accordion_title">
                        <>
                          <Heading content="Monitoring" />
                          <IconWrapper>
                            <OpenIcon>
                              <Icon icon={thinUp} size={18} />
                            </OpenIcon>
                            <CloseIcon>
                              <Icon icon={thinDown} size={18} />
                            </CloseIcon>
                          </IconWrapper>
                        </>
                      </AccordionTitle>
                      <AccordionBody className="accordion_body">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th scope="row">Server Uptime</th>
                              <td className="w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Vcpu Usage</th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Ram Usage</th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Disk Space</th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Read I/O Monitoring</th>
                              <td></td>
                              <td className="text-center"></td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Critical OS Related Services Monitoring
                              </th>
                              <td></td>
                              <td className="text-center"></td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Custom Monitoring at Application Level
                              </th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Azure Related Events Such As Service Or Region
                                Failures
                              </th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </>
                  </AccordionItem>
                </>
              </Accordion>
            </Fade>{' '}
            <Fade bottom casacde>
              <Accordion>
                <>
                  <AccordionItem className="accordion_item">
                    <>
                      <AccordionTitle className="accordion_title">
                        <>
                          <Heading content="Orchestration and Management" />
                          <IconWrapper>
                            <OpenIcon>
                              <Icon icon={thinUp} size={18} />
                            </OpenIcon>
                            <CloseIcon>
                              <Icon icon={thinDown} size={18} />
                            </CloseIcon>
                          </IconWrapper>
                        </>
                      </AccordionTitle>
                      <AccordionBody className="accordion_body">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th scope="row">Platform level support</th>
                              <td className="w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Onboarding</th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Azure resource management</th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Moving from one service tier to another
                              </th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Initiating actions from pre-defined templates
                              </th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Create runbooks in Azure</th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Configure webhooks</th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">VM level support</th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Azure snapshot creation/restore
                              </th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Managed OS upgrades and patching
                              </th>
                              <td></td>
                              <td className="text-center"></td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Managed antivirus</th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Managed backup</th>
                              <td></td>
                              <td className="text-center "></td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Remote support and troubleshooting
                              </th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Server deployments</th>
                              <td></td>
                              <td className="text-center w-20">Limited</td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Hardware configuration changes
                              </th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                OS level configuration changes
                              </th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Custom deployment activities</th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Review server logs</th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Review application error logs</th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Real time health reports and custom dashboards
                              </th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Health checks</th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </>
                  </AccordionItem>
                </>
              </Accordion>
            </Fade>{' '}
            <Fade bottom casacde>
              <Accordion>
                <>
                  <AccordionItem className="accordion_item">
                    <>
                      <AccordionTitle className="accordion_title">
                        <>
                          <Heading content="Identity and Access Management" />
                          <IconWrapper>
                            <OpenIcon>
                              <Icon icon={thinUp} size={18} />
                            </OpenIcon>
                            <CloseIcon>
                              <Icon icon={thinDown} size={18} />
                            </CloseIcon>
                          </IconWrapper>
                        </>
                      </AccordionTitle>
                      <AccordionBody className="accordion_body">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th scope="row">Administration of Azure IAM</th>
                              <td className="w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Configuration and management of Azure Key Vault
                              </th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Setup of Multi factor Authentication for cloud
                                accounts
                              </th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                RBAC and subscription management
                              </th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Single Sign-on</th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Azure Active Directory support
                              </th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </>
                  </AccordionItem>
                </>
              </Accordion>
            </Fade>{' '}
            <Fade bottom casacde>
              <Accordion>
                <>
                  <AccordionItem className="accordion_item">
                    <>
                      <AccordionTitle className="accordion_title">
                        <>
                          <Heading content="Cost Management and resource optimisation" />
                          <IconWrapper>
                            <OpenIcon>
                              <Icon icon={thinUp} size={18} />
                            </OpenIcon>
                            <CloseIcon>
                              <Icon icon={thinDown} size={18} />
                            </CloseIcon>
                          </IconWrapper>
                        </>
                      </AccordionTitle>
                      <AccordionBody className="accordion_body">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th scope="row">
                                Cloud cost budgeting, alerting and forecasting
                              </th>
                              <td className="w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Recommendations for cost optimization
                              </th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Resource right-sizing based on utilization
                              </th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Reserved instance recommendations
                              </th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </>
                  </AccordionItem>
                </>
              </Accordion>
            </Fade>{' '}
            <Fade bottom casacde>
              <Accordion>
                <>
                  <AccordionItem className="accordion_item">
                    <>
                      <AccordionTitle className="accordion_title">
                        <>
                          <Heading content="High Availability and Disaster Recovery" />
                          <IconWrapper>
                            <OpenIcon>
                              <Icon icon={thinUp} size={18} />
                            </OpenIcon>
                            <CloseIcon>
                              <Icon icon={thinDown} size={18} />
                            </CloseIcon>
                          </IconWrapper>
                        </>
                      </AccordionTitle>
                      <AccordionBody className="accordion_body">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th scope="row">
                                Provide recommendations for high availability
                              </th>
                              <td className="w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Implement Azure platform specific HA solutions
                              </th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Provide architectural guidance for Azure DR
                              </th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">
                                Fully managed ASR based Azure DR
                              </th>
                              <td></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </>
                  </AccordionItem>
                </>
              </Accordion>
            </Fade>{' '}
            <Fade bottom casacde>
              <Accordion>
                <>
                  <AccordionItem className="accordion_item">
                    <>
                      <AccordionTitle className="accordion_title">
                        <>
                          <Heading content="Security" />
                          <IconWrapper>
                            <OpenIcon>
                              <Icon icon={thinUp} size={18} />
                            </OpenIcon>
                            <CloseIcon>
                              <Icon icon={thinDown} size={18} />
                            </CloseIcon>
                          </IconWrapper>
                        </>
                      </AccordionTitle>
                      <AccordionBody className="accordion_body">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th scope="row">
                                Provide recommendations for network security
                              </th>
                              <td className="w-20"></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Create NSG</th>
                              <td></td>
                              <td className="text-center w-20">
                                <img
                                  src={silvercheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={goldcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                              <td className="text-center w-20">
                                <img
                                  src={platinumcheck}
                                  className="img-responsive"
                                  alt=""
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </AccordionBody>
                    </>
                  </AccordionItem>
                </>
              </Accordion>
            </Fade>
          </ThirdBlock>
        </Fade>

        <Fade bottom casacde>
          <FirstBlock>
            <div className="item">
              <div className="img">
                <img src={connect}></img>
              </div>
              <div className="label">Free Migration</div>
            </div>

            <div className="item">
              <div className="img">
                <img src={card}></img>
              </div>
              <div className="label">Pay As You Go</div>
            </div>
            <div className="item">
              <div className="img">
                <img src={track}></img>
              </div>
              <div className="label">Track Progress</div>
            </div>
            <div className="item">
              <div className="img">
                <img src={note}></img>
              </div>
              <div className="label">No Contracts</div>
            </div>

            <div className="item">
              <div className="img">
                <img src={box}></img>
              </div>
              <div className="label">SLA & KPI Driven</div>
            </div>

            <div className="item">
              <div className="img">
                <img src={hex}></img>
              </div>
              <div className="label">Responsive</div>
            </div>
            <div className="item">
              <div className="img">
                <img src={fast}></img>
              </div>
              <div className="label">Fast</div>
            </div>
            <div className="item" ref={myRef}>
              <div className="img">
                <img src={shield}></img>
              </div>
              <div className="label">Secure & Reliable</div>
            </div>
          </FirstBlock>
        </Fade>

        <Fade bottom casacde>
          <FourthBlock>
            <div className="title">Frequently Asked Questions</div>

            <div className="faq-content">
              <div className="content">
                <Fade bottom casacde>
                  <Accordion>
                    <>
                      <AccordionItem className="accordion_item">
                        <>
                          <AccordionTitle className="accordion_title">
                            <>
                              <Heading content="What type of payments do you take?" />
                              <IconWrapper>
                                <OpenIcon>
                                  <Icon icon={thinUp} size={18} />
                                </OpenIcon>
                                <CloseIcon>
                                  <Icon icon={thinDown} size={18} />
                                </CloseIcon>
                              </IconWrapper>
                            </>
                          </AccordionTitle>
                          <AccordionBody className="accordion_body">
                            We accept all credit and debit cards for services on
                            FlipServe – an Infrastructure services as a service
                            platform
                          </AccordionBody>
                        </>
                      </AccordionItem>
                    </>

                    <>
                      <AccordionItem className="accordion_item">
                        <>
                          <AccordionTitle className="accordion_title">
                            <>
                              <Heading content="Do you accept ACH?" />
                              <IconWrapper>
                                <OpenIcon>
                                  <Icon icon={thinUp} size={18} />
                                </OpenIcon>
                                <CloseIcon>
                                  <Icon icon={thinDown} size={18} />
                                </CloseIcon>
                              </IconWrapper>
                            </>
                          </AccordionTitle>
                          <AccordionBody className="accordion_body">
                            Based on the volume, we will explore the
                            possibility. Please connect with sales@flipserve.com
                            to discuss this further and avail the benefit of on
                            FlipServe – an Infrastructure services as a service
                            platform
                          </AccordionBody>
                        </>
                      </AccordionItem>
                    </>
                    <>
                      <AccordionItem className="accordion_item">
                        <>
                          <AccordionTitle className="accordion_title">
                            <>
                              <Heading content="I want to change my credit card, how do I do so?" />
                              <IconWrapper>
                                <OpenIcon>
                                  <Icon icon={thinUp} size={18} />
                                </OpenIcon>
                                <CloseIcon>
                                  <Icon icon={thinDown} size={18} />
                                </CloseIcon>
                              </IconWrapper>
                            </>
                          </AccordionTitle>
                          <AccordionBody className="accordion_body">
                            Navigate to the billing profile and you can add or
                            remove a card at your convenience to continue using
                            FlipServe – an Infrastructure services as a service
                            platform
                          </AccordionBody>
                        </>
                      </AccordionItem>
                    </>
                  </Accordion>
                </Fade>
              </div>
              <div className="content">
                <Fade bottom casacde>
                  <Accordion>
                    <>
                      <AccordionItem className="accordion_item">
                        <>
                          <AccordionTitle className="accordion_title">
                            <>
                              <Heading content="My credit card has been charged twice, how can I get a refund?" />
                              <IconWrapper>
                                <OpenIcon>
                                  <Icon icon={thinUp} size={18} />
                                </OpenIcon>
                                <CloseIcon>
                                  <Icon icon={thinDown} size={18} />
                                </CloseIcon>
                              </IconWrapper>
                            </>
                          </AccordionTitle>
                          <AccordionBody className="accordion_body">
                            In the event that you have been double billed, our
                            system will automatically credit your account in 5-7
                            days . If you still do not see refund, please raise
                            a support ticket to billing indicating your
                            FlipServe id and the amount and our billing team
                            will get back within 2 business days
                          </AccordionBody>
                        </>
                      </AccordionItem>
                    </>

                    <>
                      <AccordionItem className="accordion_item">
                        <>
                          <AccordionTitle className="accordion_title">
                            <>
                              <Heading content="Can I get a refund on my services?" />
                              <IconWrapper>
                                <OpenIcon>
                                  <Icon icon={thinUp} size={18} />
                                </OpenIcon>
                                <CloseIcon>
                                  <Icon icon={thinDown} size={18} />
                                </CloseIcon>
                              </IconWrapper>
                            </>
                          </AccordionTitle>
                          <AccordionBody className="accordion_body">
                            Our services are extremely competitively priced and
                            are value for money. If you wish to cancel your
                            services, please note that we will not be able to
                            refund any money paid, but your services will be
                            valid till the end of the billing cycle.
                          </AccordionBody>
                        </>
                      </AccordionItem>
                    </>

                    <>
                      <AccordionItem className="accordion_item">
                        <>
                          <AccordionTitle className="accordion_title">
                            <>
                              <Heading content="Can I get a discount code on services?" />
                              <IconWrapper>
                                <OpenIcon>
                                  <Icon icon={thinUp} size={18} />
                                </OpenIcon>
                                <CloseIcon>
                                  <Icon icon={thinDown} size={18} />
                                </CloseIcon>
                              </IconWrapper>
                            </>
                          </AccordionTitle>
                          <AccordionBody className="accordion_body">
                            FlipServe – An Infrastructure Services as a Service
                            platform offers customers multiple promotions in a
                            year, our system will indicate through your
                            registered email to you to claim the offer.
                          </AccordionBody>
                        </>
                      </AccordionItem>
                    </>
                  </Accordion>
                </Fade>
              </div>
            </div>
          </FourthBlock>
        </Fade>
      </Container>
    </>
  );
};

PricingBlock.propTypes = {
  sectionWrapper: PropTypes.object,
  secTitleWrapper: PropTypes.object,
  row: PropTypes.object,
  col: PropTypes.object,
  secHeading: PropTypes.object,
  secText: PropTypes.object,
  featureItemHeading: PropTypes.object,
  featureItemDes: PropTypes.object,
  featureTitle: PropTypes.object,
  iconStyle: PropTypes.object,
  featureItemBox: PropTypes.object,
  gobutton: PropTypes.object,
  metricscol: PropTypes.object,
  metricsrow: PropTypes.object,
  metricsItemBox: PropTypes.object,
  metricsTitle: PropTypes.object
};

export default PricingBlock;
